import $ from 'jquery';
import projectSettings from './project-settings';
import _escape from 'lodash/escape';
import 'imagesloaded';

const $body = $( '.js-product-single' );

if ( $body.length ) {

	const data = $body.data( 'product-single-data' );

	// console.log( 'data', data );

	// hero

	const $title = $body.find( '.js-product-single__title' );
	const $tags = $body.find( '.js-product-single__tags' );
	const $priceInfo = $body.find( '.js-product-single__price-info' );
	const $multivariants = $body.find( '.js-product-single__multivariants' );
	const $whereToBuyBtns = $body.find( '.js-product-single__where-to-buy-btn' );

	// primary preset content blocks

	const $primaryPresetContentBlocks = $body.find( '.js-product-single__primary-preset-content-block' );

	// features

	const $featureBulletsBlock = $body.find( '.js-product-single__feature-bullets-block' );
	const $featureBulletsList = $body.find( '.js-product-single__feature-bullets-list' );

	// documentation

	const $documentationBlocks = $body.find( '.js-product-single__documentation-block' );

	// replacement parts blocks

	const $replacementPartsBlocks = $body.find( '.js-product-single__replacement-parts-block' );

	// secondary preset content blocks

	const $secondaryPresetContentBlocks = $body.find( '.js-product-single__secondary-preset-content-block' );

	// hero sliders

	const $slider = $body.find( '.js-gallery-slider' );
	const $navSlider = $body.find( '.js-gallery-nav-slider' );

	function newReinit() {
		// fix issue where navSlider isn't clickable and can't navigate the main slider after you change the variation
		// https://github.com/kenwheeler/slick/issues/1043#issuecomment-256917237
		this._oldReinit();
		this.$slides.each( ( index, element ) => $( element ).attr( 'data-slick-index', index ) );
	}

	$slider.slick( {
		mobileFirst: false,
		infinite: false,
		autoplay: false,
		adaptiveHeight: true,
		draggable: true,
		swipe: true,
		fade: true,
		variableWidth: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		dotsClass: 'c-slider__dots',
		arrows: false,
		nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
		prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
		//appendArrows: '.slick-list',
		asNavFor: $navSlider,
		responsive: [
			{
				breakpoint: projectSettings.breakpointLG,
				settings: {
					fade: false,
				}
			}
		]
	} );
	$slider.slick( 'getSlick' )._oldReinit = $slider.slick( 'getSlick' ).reinit;
	$slider.slick( 'getSlick' ).reinit = newReinit;

	$navSlider.slick( {
		mobileFirst: false,
		infinite: false,
		autoplay: false,
		adaptiveHeight: true,
		draggable: true,
		swipe: true,
		fade: false,
		variableWidth: true,
		slidesToShow: 6,
		slidesToScroll:6,
		swipeToSlide: true,
		//centerMode: true,
		//centerPadding: '50px',
		focusOnSelect: true,
		dots: false,
		dotsClass: 'c-slider__dots',
		arrows: true,
		nextArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--next"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
		prevArrow: '<a href="" class="c-slider__arrow c-slider__arrow--base c-slider__arrow--prev"><svg class="c-slider__arrow-thick o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + window.designstudio.themeAssetsUrl + '/sprite/icons.svg#icon-chevron"></use></svg></a>',
		asNavFor: $slider,
		responsive: [
			{
				breakpoint: projectSettings.breakpointXL,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				}
			},
			{
				breakpoint: projectSettings.breakpointLG,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 6,
				}
			},
			{
				breakpoint: projectSettings.breakpointMD,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 5,
				}
			},
			{
				breakpoint: projectSettings.breakpointSM,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			}
		]
	} );
	$navSlider.slick( 'getSlick' )._oldReinit = $navSlider.slick( 'getSlick' ).reinit;
	$navSlider.slick( 'getSlick' ).reinit = newReinit;

	// multivariation switchers

	$( document ).on( 'click', '.js-product-single__finish', function ( event ) {
		event.preventDefault();

		const targetFlowRateId = data.currentProduct.flowRateId;
		const targetFinish = $( this ).data( 'finish' );

		changeMultivariant( targetFlowRateId, targetFinish );
	} );

	$( document ).on( 'click', '.js-product-finish__flow-rate-dropdown-toggle', function( event ) {
		event.preventDefault();
		$( this ).closest( '.js-product-finish__flow-rate-dropdown' ).toggleClass( 'has-dropdown-open' );
	} );

	$( document ).on( 'click', function( event ) {
		if ( ! $( event.target ).closest( '.js-product-finish__flow-rate-dropdown' ).length ) {
			$( '.js-product-finish__flow-rate-dropdown' ).removeClass( 'has-dropdown-open' );
		}
	});

	$( document ).on( 'click', '.js-product-finish__flow-rate-dropdown-item', function ( event ) {
		event.preventDefault();
		$( this ).closest( '.js-product-finish__flow-rate-dropdown' ).toggleClass( 'has-dropdown-open' );

		const targetFlowRateId = $( this ).data( 'flow-rate' );
		const targetFinish = data.currentProduct.finish;

		changeMultivariant( targetFlowRateId, targetFinish );
	} );

	// functions

	function renderTags( currentProduct ) {
		$tags.empty();

		if ( currentProduct.isObsolete || currentProduct.isModified ) {
			let tag_group_items_html = ''
			if ( currentProduct.isModified ) {
				tag_group_items_html += `
					<a href="https://designstudiobath.com?p=32563" class="c-tag c-tag--small c-tag--primary-dark">
						Modified Shower Trim <svg class="o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${ window.designstudio.themeAssetsUrl }/sprite/icons.svg#icon-info"></use></svg>
					</a>
				`;
			}
			if ( currentProduct.isObsolete ) {
				tag_group_items_html += '<span class="c-tag c-tag--small">RETIRED</span>';
			}
			$tags.append( `
				<li>
					<div class="c-tag__group">
						${tag_group_items_html}
					</div>
				</li>
			` );
		}

		$tags.append( `
			<li>
				<p class="c-subtitle">Model ${ _escape( currentProduct.sku ) }</p>
			</li>
		` );
	}

	function renderPriceInfo( currentProduct ) {

		$priceInfo.empty();

		if ( currentProduct.availabilityHtml ) {
			$priceInfo.append( `
				<div>
					<p class="c-subtitle">${ currentProduct.availabilityHtml }</p>
				</div>
			` );
		}

		if ( currentProduct.price && ! currentProduct.isObsolete ) {
			$priceInfo.append( `
				<div class="u-ml-auto">
					<div class="c-list-grid c-list-grid--small">
						<div>
							<p class="c-note">Price:</p>
						</div>
						<div>
							<div class="c-price">
								<p class="c-price__amount">
									<span class="c-price__small c-price__sup">${ _escape( currentProduct.price.sign ) }</span>
									<span class="c-price__number">${ _escape( currentProduct.price.formattedAmmount ) }</span>
									<span class="c-price__small">${ _escape( currentProduct.price.currency ) }</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			` );
		}
	}

	function getCurrentFinishVariants( currentProduct ) {
		return data.multivariants
			.filter( product => product.type === 'variant' )
			.filter( product => product.flowRateId === currentProduct.flowRateId );
	}

	function getCurrentFlowRateVariants( currentProduct ) {
		const flowRateVariants = data.multivariants
			.filter( product => product.flowRateId !== null )
			.map( product => product.flowRateId )

			// get distinct flow rate IDs
			.filter( ( flowRateId, index, self ) => self.indexOf( flowRateId ) === index )

			// get a variant for each flow rate ID
			.reduce( ( accumulator, flowRateId ) => {
				const flowRateVariant = getMultivariant( flowRateId, currentProduct.finish );
				flowRateVariant && accumulator.push( flowRateVariant );
				return accumulator;
			}, [] );

		// this function returns all flow rate variants incuding the current product
		// if there's only one flow rate variant we only have the current product inside
		// we don't want to display flow rate variant picker in this case
		return flowRateVariants.length > 1 ? flowRateVariants : [];
	}

	function renderMultivariants( currentProduct ) {

		const finishVariants = getCurrentFinishVariants( currentProduct );
		const flowRateVariants = getCurrentFlowRateVariants( currentProduct );

		// console.log( 'renderMultivariants::finishVariants', finishVariants );
		// console.log( 'renderMultivariants::flowRateVariants', flowRateVariants );

		$multivariants.empty();

		if ( finishVariants.length || flowRateVariants.length ) {

			let multivariantsHtml = '';

			// finish variants

			if ( finishVariants.length && flowRateVariants.length ) {
				multivariantsHtml += '<div class="c-product__options-col">';
			}

			if ( finishVariants.length ) {

				multivariantsHtml += `
					<div class="c-list-grid c-list-grid--small">
						<div>
							<p class="c-product__label">Finishes:</p>
						</div>
						<div>
							<ul class="c-finishes c-finishes--hor js-finish-toggles">
				`;

				finishVariants.forEach( finishVariant => {
					const finishIconUrl = window.designstudio.finishIcons[finishVariant.finish];
					multivariantsHtml += `
						<li class="${ finishVariant.sku === currentProduct.sku ? 'is-selected' : '' }">
							<a
								href="${ _escape( finishVariant.permalink ) }"
								class="js-product-single__finish"
								data-finish="${ _escape( finishVariant.finish ) }"
							>
								<span
									class="c-finishes__preview"
									style="${ finishIconUrl ? 'background-image:url(' + finishIconUrl + ')' : '' }"
								></span>
							</a>
						</li>
					`;
				} );

				multivariantsHtml += `
							</ul>
						</div>
					</div>
				`;

			}

			if ( finishVariants.length && flowRateVariants.length ) {
				multivariantsHtml += '</div>';
			}

			// flow rate variants

			if ( finishVariants.length && flowRateVariants.length ) {
				multivariantsHtml += '<div class="c-product__options-col">';
			}

			if ( flowRateVariants.length ) {

				multivariantsHtml += `
					<div class="c-list-grid c-list-grid--small">
						<div>
							<p class="c-product__label">Flow Rate:</p>
						</div>
						<div>
							<div class="c-dropdown-wrapper js-product-finish__flow-rate-dropdown">
								<a
									href="${ _escape( currentProduct.permalink ) }"
									class="c-tag c-tag--light c-tag--basic c-tag--large c-dropdown-toggle js-product-finish__flow-rate-dropdown-toggle"
								>
									<span class="c-dropdown-value js-product-finish__flow-rate-dropdown-value">
										${ _escape( currentProduct.flowRateName ) }
									</span>
								</a>
								<div class="c-dropdown c-dropdown--right">
									<div class="c-dropdown__header c-dropdown__header--sm">
										<span class="c-dropdown__title">Flow Rate:</span>
										<span class="c-dropdown__toggle js-product-finish__flow-rate-dropdown-toggle">
											<svg class="o-icon o-svg-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${ window.designstudio.themeAssetsUrl }/sprite/icons.svg#icon-close-thin"></use></svg>
										</span>
									</div>
									<div class="c-dropdown__body">
										<ul class="c-dropdown__list">
				`;

				flowRateVariants.forEach( flowRateVariant => {
					multivariantsHtml += `
						<li class="${ flowRateVariant.flowRateId === currentProduct.flowRateId ? 'is-selected' : '' }">
							<a
								href="${ _escape( flowRateVariant.permalink ) }"
								class="js-product-finish__flow-rate-dropdown-item"
								data-flow-rate="${ flowRateVariant.flowRateId }"
							>
								${ _escape( flowRateVariant.flowRateName ) }
							</a>
						</li>
					`;
				} );

				multivariantsHtml += `
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				`;
			}

			if ( finishVariants.length && flowRateVariants.length ) {
				multivariantsHtml += '</div>';
			}

			$multivariants.html( multivariantsHtml );
			$multivariants.show();

		} else {
			$multivariants.hide();
		}
	}

	function renderSlider( currentProduct ) {

		const images = data.images[ currentProduct.sku ] || [];

		// console.log( 'renderSlider::data::images', data.images );
		// console.log( 'renderSlider::images', images );

		// remove all slides

		$slider.slick( 'slickRemove', null, null, true );
		$navSlider.slick( 'slickRemove', null, null, true );

		// add new slides

		if ( images.length <= 1 ) {
			$navSlider.hide();
		} else {
			$navSlider.show();
		}

		images.forEach( image => {

			$slider.slick( 'slickAdd', `
				<div class="c-hero__gallery-item">
					<a href="${ _escape( image.original_url ) }">
						<img src="${ _escape( image.large_url ) }" />
					</a>
				</div>
			` );

			$navSlider.slick( 'slickAdd', `
				<div class="c-hero__gallery-item">
					<span>
						<img src="${ _escape( image.thumbnail_url ) }" />
					</span>
				</div>
			` );

		} );

		// position is apparently important, setting this up before the image loop doesn't work
		$slider.imagesLoaded( () => $slider.slick( 'getSlick' ).setPosition() );
		$navSlider.imagesLoaded( () => $navSlider.slick( 'getSlick' ).setPosition() );
	}

	function renderFeatureBullets( featureBullets ) {
		if ( featureBullets.length ) {
			$featureBulletsList.empty();
			featureBullets.forEach( featureBullet => {
				$featureBulletsList.append( `
					<li class="u-mb-spacer-base-large">
						<p class="c-list-feature__title">${ _escape( featureBullet ) }</p>
					</li>
				` );
			} );
			$featureBulletsBlock.show();
		} else {
			$featureBulletsBlock.hide();
		}
	}

	function getMultivariant( flowRateId, finish ) {

		// find the best sellable product to switch to

		const products = data.multivariants.filter( product => product.flowRateId === flowRateId );

		if ( ! products.length ) {
			return null;
		}

		return products.reduce( ( previousProduct, currentProduct ) => {
			return currentProduct.finish === finish ? currentProduct : previousProduct;
		}, products[0] );
	}

	function changeMultivariant( flowRateId, finish ) {

		// console.log( 'changeMultivariant::flowRateId', flowRateId );
		// console.log( 'changeMultivariant::finish', finish );

		const product = getMultivariant( flowRateId, finish );

		if ( ! product ) {
			return;
		}

		// console.log( 'changeMultivariant::product', product );

		data.currentProduct = product;

		window.history.pushState( null, '', data.currentProduct.permalink );

		$title.text( data.currentProduct.title );
		renderTags( data.currentProduct );
		renderPriceInfo( data.currentProduct );
		renderMultivariants( data.currentProduct );
		renderSlider( data.currentProduct );

		$primaryPresetContentBlocks.hide();
		$primaryPresetContentBlocks.filter( `[data-skus*="|${ $.escapeSelector( data.currentProduct.sku ) }|"]` ).show();

		renderFeatureBullets( data.currentProduct.featureBullets );

		$documentationBlocks.hide();
		$documentationBlocks.filter( `[data-skus*="|${ $.escapeSelector( data.currentProduct.sku ) }|"]` ).show();

		$replacementPartsBlocks.hide();
		$replacementPartsBlocks.filter( `[data-skus*="|${ $.escapeSelector( data.currentProduct.sku ) }|"]` ).show();

		$secondaryPresetContentBlocks.hide();
		$secondaryPresetContentBlocks.filter( `[data-skus*="|${ $.escapeSelector( data.currentProduct.sku ) }|"]` ).show();

		// TODO: render page navigation

		$whereToBuyBtns.removeClass( 'is-active' );
		$whereToBuyBtns.filter( `[ps-sku="${ $.escapeSelector( data.currentProduct.sku ) }"]` ).addClass( 'is-active' );
	}
}
